var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasErrorMessage
    ? _c(
        "div",
        _vm._l(_vm.messages, function(message) {
          return _c("p", [_vm._v(_vm._s(message))])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }